<template>
  <div class="blogCategories">
    <div class="blogCategories__header">
      <div class="container">
        <h2 class="blogCategories__title">{{ title }}</h2>
        <div class="blogCategories__tabs">
          <button
            :class="[
              'blogCategories__tab',
              { 'blogCategories__tab--active': category.id === active },
            ]"
            :key="`tab_${category.id}`"
            @click="active = category.id"
            v-for="category in categories"
          >
            {{ category.name }}
          </button>
        </div>
      </div>
    </div>
    <div class="container">
      <template v-for="category in categories">
        <div :key="`content_${category.id}`" class="blogCategories__content">
          <div v-show="category.id === active">
            <slider-tiles
              :items="category.articles"
              :ref="`sliderTiles__${category.id}`"
              content-type="news"
              watch-overflow
              slides-per-view="auto"
            />
            <div class="blogCategories__contentButton">
              <v-button
                :text="category.name"
                :to="localePath({ name: 'blog-category-slug', params: { slug: category.slug } })"
                mobile-small-height
                theme="purple"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SliderTiles from '~/components/Sliders/SliderTiles';
import VButton from '~/components/VButton';

export default {
  name: 'BlogCategories',
  components: {
    SliderTiles,
    VButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  watch: {
    active(val) {
      this.$nextTick(() => {
        this.$refs[`sliderTiles__${val}`][0].refreshSlider();
      });
    },
  },
  created() {
    this.active = this.categories[0].id;
  },
};
</script>

<style lang="scss" scoped>
.blogCategories {
  &__header {
    margin-bottom: 4rem;
    padding: 6rem 0 0;
    background-color: $cBg;
  }

  &__title {
    margin-bottom: 4rem;
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;
  }

  &__tabs {
    background-color: $cWhite;
    display: flex;
    overflow: auto;
  }

  &__tab {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 7rem;
    font-size: 1.6rem;
    line-height: 2rem;
    flex: 1;
    border-left: 1px solid $cWhite;
    border-right: 1px solid $cWhite;
    border-bottom: 1px solid $cBg;
    border-top: 3px solid $cWhite;
    transition: border $tr, background-color $tr;

    @include rwd('tablet') {
      flex: 0 0 40%;
      max-width: 40%;
    }

    @include rwd('large-phone') {
      flex: 0 0 60%;
      max-width: 60%;
    }

    &--active {
      background: rgb(247, 248, 252);
      background: linear-gradient(180deg, rgba(247, 248, 252, 1) 0%, rgba(255, 255, 255, 1) 100%);
      border-bottom: 1px solid $cWhite;
      border-left: 1px solid $cBg;
      border-right: 1px solid $cBg;
      border-top: 3px solid $cSec;
    }
  }

  &__contentButton {
    display: flex;
    justify-content: center;
    margin-top: 5rem;
  }
}
</style>
